import { Model, surveyLocalization } from 'survey-core';
import { Survey as SurveyComponent } from 'survey-react-ui';
import { inject, observer } from 'mobx-react';
import { PlainLightPanelless } from 'survey-core/themes';
import React, { useMemo } from 'react';
import { useGetQuestionnaireAnswerByTaskId } from '../../global/entities/QuestionnaireAnswer/queries/useGetQuestionnaireAnswerByTaskId.tsx';
import 'survey-core/i18n/french';
import { useTranslation } from 'react-i18next';
import { RouteStore } from '../../global/Store/RouteStore.ts';
import { Button, Divider, Flex, Paper, Stack, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { theme } from '../../global/style/theme.tsx';
import { useNavigate } from 'react-router-dom';
import { useGetTaskById } from '../../global/entities/Tasks/queries/useGetTaskById.tsx';
import { t } from 'i18next';

surveyLocalization.locales['fr'].pageNextText = 'Suivant';
surveyLocalization.locales['fr'].pagePrevText = 'Précédent';
surveyLocalization.locales['fr'].completeText = 'Terminer';

surveyLocalization.supportedLocales = ['en', 'fr'];

export interface ISurveyResultProps {
    routeStore?: RouteStore;
}

const SurveyResult: React.FC<ISurveyResultProps> = inject('routeStore')(
    observer(({ routeStore }) => {
        const { data: questionnaire } = useGetQuestionnaireAnswerByTaskId();
        const { data: task } = useGetTaskById();
        const navigate = useNavigate();

        const { i18n } = useTranslation();

        const survey = useMemo(() => {
            if (!questionnaire?.questionnaireJson) return null;

            const parsedJson = JSON.parse(questionnaire.questionnaireJson);

            const model = new Model(parsedJson);
            const surveyTheme = questionnaire.themeJson ? JSON.parse(questionnaire.themeJson) : PlainLightPanelless;
            model.applyTheme(surveyTheme);

            model.locale = i18n.language;

            if (questionnaire.answersJson) 
                model.data = JSON.parse(questionnaire.answersJson);

            model.mode = 'display';

            return model;
        }, [questionnaire, i18n.language]);

        const title = useMemo(() => {
            if (!questionnaire?.questionnaireJson) return null;

            try {
                const parsed = JSON.parse(questionnaire.questionnaireJson);
                const lang = i18n.language;

                // fallback sur 'default' si la langue n'est pas définie dans le titre
                return parsed?.title?.[lang] ?? parsed?.title?.default ?? null;
            } catch (e) {
                console.error('Erreur lors du parsing du questionnaireJson', e);
                return null;
            }
        }, [questionnaire, i18n.language]);

        if (!questionnaire?.questionnaireJson) return null;

        console.log(task);

        return (
            <Stack gap={'lg'} pt={location.pathname.includes('hcpPatientDashboard') ? 'none' : 'xl'}>
                <Flex align={'center'} justify={'space-between'}>
                    <Button
                        leftSection={<IconArrowLeft color={theme.colors?.blue?.toString()} />}
                        onClick={() => (routeStore?.lastRoute ? navigate(routeStore.lastRoute) : null)}
                        variant="transparent"
                    >
                        <Title c="black" order={3}>
                            {title}
                        </Title>
                    </Button>
                </Flex>
                <Paper>
                    <SurveyComponent model={survey} />
                    <Divider mb={'lg'} />
                    <Flex pt={'md'} justify={'flex-end'}>
                        <Button
                            size={'md'}
                            onClick={() => (routeStore?.lastRoute ? navigate(routeStore.lastRoute) : null)}
                        >
                            {t('button.close')}
                        </Button>
                    </Flex>
                </Paper>
            </Stack>
        );
    }),
);

export default SurveyResult;
